<template>
  <div class='empty' :style="{height:props.height,width:props.width}">
    <img v-if='imgRequire' :src='imgRequire' class="empty-icon"/>
    <img v-else src='../../../assets/home/empty.svg' class="empty-icon"/>
    <p class="msg"><slot></slot></p>
  </div>
</template>

<script setup>
const props = defineProps({
  height: {
    type:String,
    default:'100%'
  },
  width: {
    type:String,
    default:'100%'
  },
  imgRequire: {
    type: String,
  },
})
</script>

<style lang="less" scoped>
.empty{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .empty-icon{
    width: 200px;
    height: 145px;
  }
  .msg{
    margin-top: -20px;
    color:  #9499A0;
    font-size: 14px;
    font-weight: 500;
  }
}
</style>